import { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import { Routes, Route } from "react-router-dom";
import Header from "./components/global/Header";
import ReportsList from "./components/ReportsList";
import Login from "./components/Login";
import Register from "./components/Register";
import Terms from "./components/Terms";
import Forgot from "./components/Forgot";
import QR from "./components/Qr";
import Account from "./components/Account";
import ReportsAdd from "./components/ReportsAdd";
import Transport from "./components/Transport";
import TransportDocuments from "./components/TransportDocuments";
import Scrap from "./components/Scrap";
import SingleReport from "./components/SingleReport";
import Invoices from "./components/Invoices";

import { useLocation } from "react-router-dom";

import { API } from "./api/api";


function App() {

  // isUserLoggedIn is a placeholder for actual authentication logic
  const [user, setUser] = useState({});
  const [cookies, setCookie] = useCookies(['token', 'user']);
  const [token, setToken] = useState(cookies.token || '');
  const [addSuccess, setAddSuccess] = useState('');
  const location = useLocation(); // <-- get current route
  const [selectedDepot, setSelectedDepot] = useState("all");


  const apiCall = (method, endpoint, data = []) => {
    // console.log("API Call:", method, endpoint, data);
    let call = API(method, endpoint, data, token);
    //if unathorised error, clear cookies and redirect to login
    call.catch(error => {
      console.log("Error API Call:", method, endpoint, data);
      if (error.message.includes('401')) {
        console.log(user);
        setCookie('token', '', { path: '/' });
        setToken('');
        // setCookie('user', '', { path: '/' });
        setUser({});
        window.location.href = '/login'; // Redirect to login page
      }
    });
    return call;

  };


  //if user is logged in, set body class to 'page-body compact-wrapper dark-sidebar'
  useEffect(() => {

    // check if user exists in cookies
   
      // if user is not logged in, check if token exists, but do it only once
      if (!user?.id && token) {
        //async function to fetch user data
        apiCall("GET", "user")
          .then(({ response, error }) => {
            if (error) {
              // setUser({});
            } else {
              console.log("Resp:", response);
              if (response) {
                setUser(response);
                //save user data to cookies
                // setCookie('user', response, { path: '/' });
              }
            }
          });
      }
    

  }, [user]);// eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div className="page-wrapper compact-wrapper dark-sidebar" id="pageWrapper">
      {(<Header user={user} setCookie={setCookie} route={location.pathname} />)}

      <div className="page-body-wrapper">
        <div className="page-body no-sidebar">
          <div className="container-fluid">
            <Routes>
              <Route path="/" element={(<ReportsList apiCall={apiCall} user={user} />)} />
              <Route path="/add" element={<ReportsAdd apiCall={apiCall} user={user} setAddSuccess={setAddSuccess} />} />
              <Route path="/login" element={!user?.id && (<Login setUser={setUser} apiCall={apiCall} setCookie={setCookie} setToken={setToken} addSuccess={addSuccess} />)} />
              <Route path="register" element={!user?.id && (<Register setUser={setUser} apiCall={apiCall} setCookie={setCookie} setToken={setToken} />)} />
              <Route path="terms" element={<Terms apiCall={apiCall} />} />
              <Route path="/forgot" element={<Forgot apiCall={apiCall} />} />
              <Route path="/qr" element={<QR />} />
              <Route path="/account" element={user?.id && (<Account apiCall={apiCall} user={user} setCookie={setCookie} />)} />
              <Route path="/transport" element={user?.id && (<Transport apiCall={apiCall} user={user} selectedDepot={selectedDepot} setSelectedDepot={setSelectedDepot} />)} />
              <Route path="/transport-documents" element={user?.id && (<TransportDocuments apiCall={apiCall} user={user} selectedDepot={selectedDepot} setSelectedDepot={setSelectedDepot} />)} />
              <Route path="/invoices" element={user?.id && (<Invoices apiCall={apiCall} user={user} selectedDepot={selectedDepot} setSelectedDepot={setSelectedDepot} />)} />
              <Route path="/reports/:id/" element={<SingleReport apiCall={apiCall} />} />
              <Route path="/reports/:id/scrap" element={<Scrap apiCall={apiCall} user={user} />} />

            </Routes>
          </div>


        </div>
      </div>
    </div>
  );
}

export default App;
